import { Component, inject } from '@angular/core';
import { SoilAptitudeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SoilAptitudeCreateDto,
  SoilAptitudeDto,
  SoilAptitudeExcelDownloadDto,
  SoilAptitudeUpdateDto,
} from '../proxy/planning/dtos/soil-aptitude';
import { SOILAPTITUDE_CONFIG, SOILAPTITUDE_FIELDS } from './soil-aptitude.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-soil-aptitude',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SoilAptitudeService, ConfirmationService],
  templateUrl: './soil-aptitude.html',
  styleUrl: './soil-aptitude.scss',
})
export class SoilAptitude extends BaseCrudComponent<
  SoilAptitudeDto,
  SoilAptitudeCreateDto,
  SoilAptitudeUpdateDto,
  SoilAptitudeExcelDownloadDto
> {
  service = inject(SoilAptitudeService);
  config = SOILAPTITUDE_CONFIG;
  fields = SOILAPTITUDE_FIELDS;

  protected prepareUpdateDto(data: any, selected: SoilAptitudeDto): SoilAptitudeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SoilAptitude';
  }
}
